// extracted by mini-css-extract-plugin
export default {"stackItem":"StackItem_stackItem__4Rb3z","mailChimp":"StackItem_mailChimp__uKK3-","stack_meta":"StackItem_stack_meta__BL73O","guide_meta_time":"StackItem_guide_meta_time__ZkCjg"};